import React from 'react';
import cx from 'classnames';

import styles from './Avatar.scss';

type Props = {
  avif: string;
  img: string;
  name: string;
  title: string;
  webp: string;
};

const Avatar = ({ avif, img, name, title, webp }: Props) => (
  <div className={styles.avatar}>
    <div className={styles.photo}>
      <picture>
        <source srcSet={avif} type="image/avif" />
        <source srcSet={webp} type="image/webp" />
        <img
          alt={name}
          className={styles.img}
          height="352"
          loading="lazy"
          src={img}
          width="352"
        />
      </picture>
    </div>
    <span className={cx('mw-title-title5', styles.name)}>{name}</span>
    <span className="mw-title-large">{title}</span>
  </div>
);

export default Avatar;
